import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PAID_SUBSCRIPTION_ROUTES, FREE_SUBSCRIPTION_ROUTES, PUBLIC_ROUTES } from 'src/constants/routes';

const subscriptionLockedRoutes = Object.values(PAID_SUBSCRIPTION_ROUTES);
const subscriptionUnavailableRoutes = [
  FREE_SUBSCRIPTION_ROUTES.ACCOUNT_SUBSCRIPTIONS,
  FREE_SUBSCRIPTION_ROUTES.ACCOUNT_SUBSCRIPTION_PLAN,
];
const toRouteRegex = routePattern => new RegExp(`^${routePattern.replace(/:[^/]+/g, '[^/]+')}(?:/.*)?$`);

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const isLogged = useSelector(state => state.user.isAuthenticated);
  const greetingWizardShow = useSelector(state => state.user?.currentUserData?.greeting_wizard?.show);
  const accreditationPayed = useSelector(state => state.user?.currentUserData?.profile?.accreditation_payed);
  return (
    <Route
      {...rest}
      render={props => {
        if (!isLogged) {
          return <Redirect to={PUBLIC_ROUTES.LOGIN} />;
        }
        if (greetingWizardShow && location.pathname !== FREE_SUBSCRIPTION_ROUTES.ACCOUNT_ONBOARDING) {
          return <Redirect to={FREE_SUBSCRIPTION_ROUTES.ACCOUNT_ONBOARDING} />;
        }

        const shouldRedirectFromUnavailableSubscriptions = subscriptionUnavailableRoutes.some(route =>
          toRouteRegex(route).test(location.pathname)
        );

        if (shouldRedirectFromUnavailableSubscriptions) {
          return <Redirect to={FREE_SUBSCRIPTION_ROUTES.ACCOUNT_DASHBOARD} />;
        }

        const shouldRedirectFromPaidRoute = subscriptionLockedRoutes.some(route =>
          toRouteRegex(route).test(location.pathname)
        );

        if (
          !accreditationPayed &&
          shouldRedirectFromPaidRoute &&
          location.pathname !== FREE_SUBSCRIPTION_ROUTES.ACCOUNT_DASHBOARD
        ) {
          return <Redirect to={FREE_SUBSCRIPTION_ROUTES.ACCOUNT_DASHBOARD} />;
        }

        return <Component {...props} />;
      }}
    />
  );
};
